export default __webpack_public_path__ + "static/Graphik-BoldItalic-Web-384dfcda11518e4a4697d6d6a52477c6.eot";